import {
  CustomCultureStatusIcon,
  CustomCultureStatusResponse,
} from '~/api/backend/customCultureStatusAPI'

export interface SystemCultureStatus {
  name: string
  icon: CustomCultureStatusIcon
  isTerminatedStatus: boolean
  isSystemStatus: true
}

export interface CustomCultureStatus {
  name: string
  icon: CustomCultureStatusIcon
  isTerminatedStatus: boolean
  isSystemStatus: false
  createdAt: string
  modifiedAt: string
  archivedAt: string | null
}

export type CultureStatus = SystemCultureStatus | CustomCultureStatus

export const SYSTEM_CULTURE_STATUSES: CultureStatus[] = [
  {
    name: 'Active',
    icon: 'ACTIVE',
    isTerminatedStatus: false,
    isSystemStatus: true,
  },
  {
    name: 'Terminated',
    icon: 'TERMINATED',
    isTerminatedStatus: true,
    isSystemStatus: true,
  },
]

export const CULTURE_STATUS_ICONS: CustomCultureStatusIcon[] = [
  'ACTIVE',
  'READY',
  'QUESTION',
  'ALERT',
  'PASSAGED',
  'TERMINATED',
]

export function parseCustomCultureStatusResponse(
  response: CustomCultureStatusResponse,
): CustomCultureStatus {
  return {
    name: response.name,
    icon: response.icon,
    isTerminatedStatus: response.category === 'terminated',
    isSystemStatus: false,
    createdAt: response.created_at,
    modifiedAt: response.updated_at,
    archivedAt: null,
  }
}

export function isSystemCultureStatus(
  status: CultureStatus,
): status is SystemCultureStatus {
  return status.isSystemStatus
}

export function isCustomCultureStatus(
  status: CultureStatus,
): status is CustomCultureStatus {
  return !status.isSystemStatus
}
